import { render, staticRenderFns } from "./ReTasksEdit.vue?vue&type=template&id=e808b040&scoped=true"
import script from "./ReTasksEdit.vue?vue&type=script&lang=js"
export * from "./ReTasksEdit.vue?vue&type=script&lang=js"
import style0 from "./ReTasksEdit.vue?vue&type=style&index=0&id=e808b040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e808b040",
  null
  
)

export default component.exports